module.exports = __webpack_public_path__ + "static/media/bg.1b2d4a14.png";